import React from "react";
import { Box, TextField, Select, MenuItem, Grid } from "@mui/material";

const AccommodationFilters = () => {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
      <TextField label="Location" defaultValue="Berlin" size="small" />
      <TextField
        label="Check-in / Check-out"
        defaultValue="10/28 – 11/01"
        size="small"
      />
      <Select defaultValue={4} size="small">
        <MenuItem value={2}>2 Sleeps</MenuItem>
        <MenuItem value={4}>4 Sleeps</MenuItem>
        <MenuItem value={6}>6 Sleeps</MenuItem>
      </Select>
    </Box>
  );
};

export default AccommodationFilters;
